import { ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges, } from '@angular/core';
import { ReplaySubject, Subject, } from 'rxjs';
import { map, switchMap, } from 'rxjs/operators';
var UiSettingForm = /** @class */ (function () {
    function UiSettingForm(_cd, _appState) {
        var _this = this;
        this._cd = _cd;
        this._appState = _appState;
        this._destroyed$ = new Subject();
        this._permission$ = new ReplaySubject(1);
        this.isReadOnly$ = this._permission$
            .pipe(switchMap(function (permission) { return _this._appState.user.permissions.isGranted(permission); }), map(function (isGranted) { return !isGranted; }));
    }
    Object.defineProperty(UiSettingForm.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        set: function (value) {
            this._settings = value;
        },
        enumerable: true,
        configurable: true
    });
    UiSettingForm.prototype.ngOnChanges = function (changes) {
        if (!changes.permission) {
            return;
        }
        this._permission$.next(changes.permission.currentValue);
    };
    UiSettingForm.prototype.ngOnDestroy = function () {
        this._destroyed$.next(true);
        this._destroyed$.complete();
    };
    return UiSettingForm;
}());
export { UiSettingForm };
